import { daisukeAuth0Store } from '@tsyl/daisuke-auth-plugin'

export const CATALOG_PERMISSION = 'manage:metric-layer-assignments'

// Same name as backend's FeatureFlagNames.MetricLayerAssignments — gates the assign/unassign
// controls behind a GitLab/Unleash flag on top of CATALOG_PERMISSION (D2501-136).
export const METRIC_LAYER_ASSIGNMENTS_FLAG = 'metriclayerassignments'

export function requireCatalogAccess(): boolean | string {
  return daisukeAuth0Store().hasPermission(CATALOG_PERMISSION) ? true : '/'
}

export function canAccessCatalog(): boolean {
  return !!daisukeAuth0Store().hasPermission(CATALOG_PERMISSION)
}
